import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-footer',
  templateUrl: './app-sidebar-footer.component.html'
})
export class AppSidebarFooterComponent { }



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/components/app-sidebar-footer/app-sidebar-footer.component.ts